import { CoreImageViewService } from '../services/core-image-view.service';
import { attachImageHoverPreview } from './image-hover-preview.util';

/**
 * Builds an AG Grid cellRenderer that shows an eye icon indicating whether a
 * row has images: theme-blue when it does, light grey when it doesn't.
 * Only the theme-blue (has-image) icon is clickable — it invokes onClick
 * with the row's cellRenderer params and fetches/shows the entity's first
 * image as a small thumbnail preview on hover. The light-grey (no-image)
 * icon is inert: no pointer cursor, no click handler, no hover preview.
 */
export function createImageStatusIconCellRenderer(
  onClick: (params: any) => void,
  coreImageView: CoreImageViewService,
  entityType: string,
  getEntityId: (params: any) => number = (params: any): number => params.data.id
): (params: any) => HTMLElement {
  return (params: any): HTMLElement => {
    const icon = document.createElement('i');
    const hasImage = !!params.value;
    icon.className = hasImage
      ? 'la la-eye la-lg text-primary'
      : 'la la-eye la-lg text-muted';
    if (hasImage) {
      icon.style.cursor = 'pointer';
      icon.onclick = () => onClick(params);
      attachImageHoverPreview(icon, () =>
        coreImageView.getFirstImageUrl(entityType, getEntityId(params))
      );
    }
    return icon;
  };
}
